import modelBaseV2 from "../model-base-v2.model";

/**
 * User Role Function Map Model
 * 
 * Contains all the requests used by User Role Function Map
 * 
 * @author cmcnkhiep(Ryan)
 */
const UserRoleFunctionMapModel = {
  getUserRoleDataAccess: (params) => {
    const queryString = modelBaseV2.toQueryString(params);
    return modelBaseV2.get(`/api/userrole/dataaccess?${queryString}`);
  },
  updateUserRoleDataAccess: (body) => {
    return modelBaseV2.post('/api/userrole/dataaccess', { body });
  },
  downloadExcel: (fileName) => {
    return modelBaseV2.postDownload('/api/userrole/dataaccess/excel', {}, fileName + ".xlsx")
  }

}

export default UserRoleFunctionMapModel;